import React, { Component } from 'react';
import { Tree, Input, Tooltip, Icon, Button, Table, Modal, message, Popconfirm, Select, Spin, Dropdown, Menu } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';
import './index.less';
import UpdateCatalog from './UpdateCatalog';
import moment from 'moment';
import ExportUtil from '../../../common/ExportUtil';
import UploadFileModal from './UploadFileModal';
import PermissionConfig from './PermissionConfig';
import UploadFolderModal from './UploadFolderModal';
import FolderUploadProgress from './FolderUploadProgress';
import FileLogModal from './FileLogModal';
import { checkAndDownloadFolder } from './FolderDownload';
import FolderMoveToInv from './FolderMoveToInv';
import MoveFolderModal from './MoveFolderModal';

const TreeNode = Tree.TreeNode;
const Search = Input.Search;
const Option = Select.Option;


class DepartmentalDocuments extends Component {
    // 定义文件大小限制常量
    MAX_SINGLE_FILE_SIZE = 2 * 1024 * 1024 * 1024; // 2GB in bytes
    MAX_FOLDER_TOTAL_SIZE = 15 * 1024 * 1024 * 1024; // 15GB in bytes

    state = {
        treeData: [],   //目录数据
        simplifyTreeData: [],
        tableData: [],  //表格数据
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
        expandedKeys: [],
        searchValue: '',
        fileNameSearchValue: '',
        autoExpandParent: true,
        selectedRowKeys: [],
        selectedKeys: [],
        arry: [],
        clearArry: false,
        imageUrl: '',
        pathName: '', //路径名称
        curPremission: '',  //权限
        curOtherPremission: '',  //其他权限（CRC上传/下载）
        canAddFirCatalog: false, //可添加一级目录权限


        // 以下字段均为上传文件夹用到的字段
        selectedFiles: [], // 选中的文件列表
        folderName: '', // 选中的文件夹名
        uploadStatus: 'idle', // idle/上传中/success/error
        totalSize: 0, // 总文件大小（字节）
        completedSize: 0, // 已完成上传+处理的文件总字节
        currentFileUploaded: 0, // 当前文件已上传字节（发送阶段）
        currentFileTotal: 0, // 当前文件的总字节（用于判断是否发送完成）
        totalFiles: 0, // 总文件数量
        uploadedFiles: 0, // 已上传+处理成功的文件数
        uploadId: '', // 上传ID
        currentFileIndex: -1, // 当前正在上传的文件索引
        failedFiles: [], // 上传失败的文件列表
        isProcessing: false, // 标记：当前文件是否处于后台处理阶段（发送完成，等待响应）
        version: '', //文件夹版本号
        fileCatalogPath: '',  // 新增文件夹的路径
    }

    xhr = null; // 当前正在上传的XHR实例
    isCanceled = false; // 标记是否手动取消上传

    // Tree 渲染缓存 — 仅在 treeData/searchValue/canAddFirCatalog 变化时重建 JSX
    // 消除每次 setState（展开/选中/搜索）都 O(N) 全量重建 TreeNode 的卡顿
    _renderedTreeCache = null;
    _lastTreeData = null;
    _lastSearchValue = undefined;
    _lastCanAddFirCatalog = undefined;

    componentDidMount = () => {
        // 创建文件夹选择input
        this.fileInput = document.createElement('input');
        this.fileInput.type = 'file';
        this.fileInput.webkitdirectory = true;
        this.fileInput.directory = true;
        this.fileInput.multiple = true;
        this.fileInput.style.display = 'none';
        this.fileInput.addEventListener('change', this.handleFileSelect);
        document.body.appendChild(this.fileInput);

        this.loadData();
        this.queryFirstIndexCatalog(); 
    };

    componentWillUnmount = () => {
        // 清理上传文件夹资源
        this.isCanceled = true;
        if (this.xhr) {
            this.xhr.abort();
        }
        this.fileInput.removeEventListener('change', this.handleFileSelect);
        document.body.removeChild(this.fileInput);
    };

    loadData = () => {
        const { selectedKeys, pathName } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.deptFile.queryFileCatalog,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { catalogs = [] } = res;
                const data = [ ...catalogs ];
                const simplifyTreeData = this.flattenList(data);
                
                const { catalogName, id, premission, otherPremission } = catalogs[0] || {};

                this.setState({
                    loading: false,
                    treeData: data,
                    simplifyTreeData,
                    selectedKeys: !selectedKeys.length ? [String(id)] : selectedKeys,
                    catalogId: this.state.catalogId ? this.state.catalogId : id,
                    pathName: !selectedKeys.length ? `${catalogName}` : pathName,
                    curPremission: premission,
                    curOtherPremission: otherPremission || '',
                }, () => {
                    this.queryTableData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    //数组扁平化
    flattenList = list => {
        const result = [];
        // 递归遍历函数
        const traverse = (nodes) => {
            nodes.forEach((node) => {
                result.push({ ...node }); // 浅拷贝节点，避免修改原数据
                if (node.children) {
                    traverse(node.children);
                }
            });
        };
        traverse(list);
        return result;
    }

    queryTableData = () => {
        const { catalogId, pagination, curPremission } = this.state;
        const { current, pageSize } = pagination;
        if (!catalogId) {
            return
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.deptFile.queryDepartmentFile,
            data: {
                offset: current,
                limit: pageSize,
                catalogId,
            },
            dataType: 'json',
            doneResult: res => {
                const { arry, clearArry } = this.state;
                const { departmentFiles = {} } = res;
                const { datas, totalCount } = departmentFiles;

                pagination.total = totalCount;
                datas.forEach((item, index) => item.index = (current - 1) * pageSize + index + 1);

                // 筛序勾选标记数据
                let newArry;
                const newSelectedRowKeys = [];
                if (clearArry) {
                    newArry = arry.filter(item => datas.some(innerItem => innerItem.id == item));
                } else {
                    newArry = arry;
                }
                newArry.forEach(item => {
                    const selectData = datas.find(innerItem => innerItem.id == item);
                    if (selectData) {
                        newSelectedRowKeys.push(selectData.index);
                    }
                });

                this.setState({
                    loading: false,
                    pagination,
                    tableData: !!curPremission ? datas : [],
                    arry: newArry,
                    selectedRowKeys: newSelectedRowKeys,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }



    // 获取添加一级目录的权限
    queryFirstIndexCatalog = () => {
        const options = {
            method: 'POST',
            url: API_URL.deptFile.queryFirstIndexCatalog,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { userIds } = res;
                const canAddFirCatalog = (userIds || []).some(el => el == sessionStorage.userId);
                this.setState({
                    canAddFirCatalog,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    downloadFileBatch = () => {
        const { arry, catalogId, tableData } = this.state;
        if (arry.length == 0) {
            return message.warning('请选择需要批量下载的文件')
        }
        ExportUtil.export({ fileIds: arry.join(','), catalogId }, null, API_URL.deptFile.downloadBatchFile);
        const operateFile = tableData.filter(item => arry.includes(item.id)).map(item => item.fileName).join(',');
        this.submitAddFileLog('BATCH_DOWNLOAD', operateFile);
        message.success('正在下载中!');
    }

    preview = (id, fileName) => {
        const formatData = ["xlsx", "pdf", "doc", "png","docx"];
        const suffix = fileName.split('.').pop();
        if (formatData.some(el => el == suffix)) {
            message.success('文档加载中，请稍后', 0);
        } else {
            message.error('该文件格式不支持预览');
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.deptFile.previewFile,
            data: {
                id,
            },
            dataType: 'json',
            doneResult: res => {
                message.destroy();
                const { str } = res;
                if (str) {
                    //解析base64编码
                    const base64Data = str.replace(/^data:.*?;base64,/, '')  // 去除 Data URL 前缀
                    .replace(/[^A-Za-z0-9+/=]/g, '')    // 过滤非法字符
                    .padEnd(str.length + (4 - (str.length % 4)) % 4, '='); // 补全填充符
                    const binaryString = window.atob(base64Data);
                    const byteArray = new Uint8Array(binaryString.length);
                    for (let i = 0; i < binaryString.length; i++) {
                        byteArray[i] = binaryString.charCodeAt(i);
                    }
                    //转化为blob对象，获取url
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const imageUrl = URL.createObjectURL(blob);
                    window.open(`${imageUrl}`);
                }
                
            },
            errorResult: () => {
                message.destroy();
            }
        };
        $.sendRequest(options);
    }

    downloadFile = (id, fileName) => {
        ExportUtil.export({ fileId: id }, null, API_URL.deptFile.downloadFile);
        message.success('正在下载中!');
        this.submitAddFileLog('DOWNLOAD', fileName);
    }

    // 提取文件名（兼容URL编码和路径截取）
    getFileName = (url) => {
        // 去除查询参数和哈希部分
        const cleanUrl = url.split('?')[0].split('#')[0];
        // 获取最后一个路径段并解码中文
        const fileNameSegment = cleanUrl.split('/').pop();
        return decodeURIComponent(fileNameSegment);
    };

    deleteFileManage = (id) => {
        const options = {
            method: 'POST',
            url: API_URL.deptFile.deleteFile,
            data: {
                id,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.message);
                this.queryTableData();
            },
        };
        $.sendRequest(options);
    }

    deleteCatalog = (catalogId, catalogIndex) => {
        let url = '';
        if (catalogIndex == 1) {
            url = API_URL.deptFile.deleteFirstIndexCatalog;  //删除一级目录
        } else {
            url = API_URL.deptFile.deleteFileCatalog;   //删除目录
        } 
        Modal.confirm({
            iconType: 'question-circle',
            title: <div style={{ marginLeft: 42 }}>确定要删除该目录吗？</div>,
            content: '删除后无法恢复，相关已上传文件也会一起删除',
            onOk: () => {
                const options = {
                    method: 'POST',
                    url,
                    data: {
                        catalogId,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                        this.loadData();
                    },
                };
                $.sendRequest(options);
            },
        });
    }

    onExpand = (expandedKeys) => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }

    onTreeNodeSelect = (selectedKeys) => {
        this.setState({ selectedKeys });
    }

    onSelect = (id) => {
        const { treeData, pagination, simplifyTreeData } = this.state;
        const found = simplifyTreeData.find(el => el.id == id);
        const path = this.findNodePath(treeData, id);
        const pathName = (path || []).map((node) => node.catalogName).join('-->');
        this.setState({
            pathName,
            pagination: {
                ...pagination,
                current: 1,
            },
            catalogId: id,
            clearArry: true,
            curPremission: found.premission,
            curOtherPremission: found.otherPremission || '',
        }, () => {
            this.queryTableData();
        })
    }

    // 递归查找节点路径
    findNodePath = (nodes, targetKey, path = []) => {
        for (const node of nodes) {
            const currentPath = [...path, node];
            if (node.id == targetKey) {
                return currentPath;
            }
            if (node.children) {
                const found = this.findNodePath(node.children, targetKey, currentPath);
                if (found) return found;
            }
        }
        return null;
    };

    /**
     * 文件夹搜索框内容变化（空时清除高亮）
     */
    onFolderSearchChange = (e) => {
        const value = e.target.value;
        if (!value) {
            this.setState({
                expandedKeys: [],
                searchValue: '',
                autoExpandParent: true,
            });
        }
    }

    /**
     * 文件夹搜索（回车或点击搜索按钮触发）
     */
    onFolderSearch = (value) => {
        if (!value) {
            this.setState({
                expandedKeys: [],
                searchValue: '',
                autoExpandParent: true,
            });
            return;
        }
        const { simplifyTreeData } = this.state;
        const expandedKeys = [];
        const found = simplifyTreeData.find(el => el.catalogName.indexOf(value) > -1);
        if (found) {
            expandedKeys.push(String(found.id));
        }
        this.setState({
            expandedKeys,
            searchValue: value,
            autoExpandParent: true,
        });
    }

    /**
     * 根据文件名模糊搜索目录树（调用后端接口）
     */
    loadDataByFileName = (fileName) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.deptFile.queryFileCatalogByFileName,
            data: { fileName },
            dataType: 'json',
            doneResult: res => {
                const catalogs = (res && res.catalogs) || [];
                const data = [ ...catalogs ];
                const simplifyTreeData = this.flattenList(data);
                // 展开搜索结果中的所有节点
                const expandedKeys = simplifyTreeData.map(el => String(el.id));
                this.setState({
                    loading: false,
                    treeData: data,
                    simplifyTreeData,
                    expandedKeys,
                    autoExpandParent: true,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    /**
     * 文件名搜索框内容变化
     * 内容为空时恢复原始目录树
     */
    onFileNameChange = (e) => {
        const value = e.target.value;
        if (!value) {
            // 清空搜索框，恢复原始目录树
            this.setState({ fileNameSearchValue: '' });
            this.loadData();
        } else {
            this.setState({ fileNameSearchValue: value });
        }
    }

    /**
     * 文件名搜索（回车或点击搜索按钮触发）
     */
    onFileNameSearch = (value) => {
        if (value) {
            this.loadDataByFileName(value);
        }
    }

    updateCatalog = (key, id, catalogName) => {
        this.UpdateCatalogRef.show(key, id, catalogName)
    }
    viewFilelog = () => {
        this.FileLogModalRef.show();
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: '文件名称',
            dataIndex: 'fileName',
            key: 'fileName',
            width: 160,
        }, {
            title: '大小',
            dataIndex: 'fileSize',
            key: 'fileSize',
            width: 100,
        }, {
            title: '上传人员',
            dataIndex: 'uploadUserName',
            key: 'uploadUserName',
            width: 100,
        }, {
            title: '上传时间',
            dataIndex: 'uploadTime',
            key: 'uploadTime',
            width: 120,
            render: text => text ? moment(text).format('YYYY-MM-DD') : ''
        }, {
            title: '版本号',
            dataIndex: 'version',
            key: 'version',
            width: 100,
        }];
        columns.push({
            title: "操作",
            key: "operate",
            dataIndex: "operate",
            width: 110,
            render: (text, record) => {
                const { id, fileName, uploadUser } = record;
                const { curPremission, curOtherPremission } = this.state;
                const formatData = ["xlsx", "pdf", "doc", "png","docx"];
                const suffix = fileName.split('.').pop();
                const isPreview = formatData.some(el => el == suffix);
                const canDownload = curPremission == 'COMMON' || curPremission == 'OWNER' || (curOtherPremission || '').split(',').includes('DOWNLOAD_FILE');
                const canDelete = curPremission == 'OWNER' || String(uploadUser) == sessionStorage.userId;
                return (
                    <span>
                        {
                            isPreview && <a onClick={() => this.preview(id, fileName)}>预览</a>
                        }

                        {
                            canDownload && isPreview && <span className="ant-divider" />
                        }
                        {
                            canDownload && <a onClick={() => this.downloadFile(id, fileName)}>下载</a>
                        }
                        {
                            canDelete && (canDownload || isPreview) && <span className="ant-divider" />
                        }
                        {
                            canDelete && <Popconfirm title='确定要删除吗？删除后无法恢复，相关已上传文件也会一起删除' onConfirm={() => this.deleteFileManage(id)} okText="确定" cancelText="取消">
                                <a>删除</a>
                            </Popconfirm>
                        }
                        {
                            curPremission == 'OWNER' && (canDelete || canDownload || isPreview) && <span className="ant-divider" />
                        }
                        {
                            curPremission == 'OWNER' && <a onClick={() => this.showMoveFile(id, fileName)}>移动</a>
                        }
                    </span>
                );
            }
        });
        return columns
    }


    onSelectChange = (record, selected) => {
        const { selectedRowKeys, arry } = this.state;
        if (selected) {
            const isExist = selectedRowKeys.some(item => item == record.index);
            !isExist && selectedRowKeys.push(record.index);
            const isIdExist = arry.some(item => item == record.id);
            if (!isIdExist) {
                arry.push(record.id);
            }
        } else {
            let idx;
            selectedRowKeys.forEach((item, index) => {
                if (record.index == item) {
                    idx = index;
                }
            });
            (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

            // 删除已存在的id
            let idIdx;
            arry.forEach((item, index) => {
                if (record.id == item) {
                    idIdx = index;
                }
            });
            if (idIdx || (!idIdx && idIdx === 0)) {
                arry.splice(idIdx, 1);
            }
        }
        this.setState({
            arry,
            selectedRowKeys,
        });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        const { arry, selectedRowKeys } = this.state;
        if (selected) {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                !(idx || (!idx && idx === 0)) && selectedRowKeys.push(item.index);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item.id) {
                        idIdx = index;
                    }
                });
                if (!(idIdx || (!idIdx && idIdx === 0))) {
                    arry.push(item.id);
                }
            });
        } else {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item.id) {
                        idIdx = index;
                    }
                });
                if (idIdx || (!idIdx && idIdx === 0)) {
                    arry.splice(idIdx, 1);
                }
            });
        }
        this.setState({
            arry,
            selectedRowKeys,
        });
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
            clearArry: false,
        }, () => {
            this.queryTableData();
        });
    }

    //判断字段是否等于某些值
    booleanEquals = (key, value = []) => {
        return value.some((el) => key === el);
    };

    handleMenuClick = (e) => {
        if (e.key == 'file') {
            this.UploadFileModalRef.show();
        } else if (e.key == 'folder') {
            this.UploadFolderModalRef.show();
        }
    }

    configPermission = (record) => {
        this.PermissionConfigRef.show(record);
    }

    /**
     * 打开迁移到项目内的弹框
     */
    moveFolderToInv = (catalogId, catalogName, catalogIndex) => {
        if (catalogIndex == 1) {
            message.warning('一级目录不允许迁移');
            return;
        }
        this.FolderMoveToInvRef.show(catalogId, catalogName);
    }

    /**
     * 打开移动文件夹弹框（部门内移动）
     */
    showMoveFolder = (catalogId, catalogName) => {
        this.MoveFolderModalRef.showMoveFolder(catalogId, catalogName);
    }

    /**
     * 打开移动文件弹框（部门内移动）
     */
    showMoveFile = (fileId, fileName) => {
        this.MoveFolderModalRef.showMoveFile(fileId, fileName);
    }

    /**
     * 下载文件夹
     */
    downloadFolder = (catalogId, catalogName, catalogIndex) => {
        // 一级目录不允许下载
        if (catalogIndex == 1) {
            message.warning('一级目录不允许下载');
            return;
        }
        checkAndDownloadFolder(catalogId, catalogName, (id, name) => {
            this.submitAddFileLogForDownloadCatalog('DOWNLOAD_CATALOG', name, id);
        });
    }


    // -----------------------------------------------------------------------------
    // 以下方法均为上传文件夹所用到的方法

    // 文件夹上传成功后调用的回调函数
    uploadFolderSuccess = (uploadId) => {
        const options = {
            method: 'POST',
            url: API_URL.deptFile.uploadSuccess,
            data: { uploadId },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    };

    // 选择文件夹+大小校验
    handleFileSelect = (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        // 1. 单个文件大小校验（≤2G）
        const oversizedFiles = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.size > this.MAX_SINGLE_FILE_SIZE) {
                oversizedFiles.push({
                    name: file.name,
                    size: this.formatSize(file.size),
                    maxSize: this.formatSize(this.MAX_SINGLE_FILE_SIZE)
                });
            }
        }
        if (oversizedFiles.length > 0) {
            let tipText = '以下文件超过单个文件大小限制（≤2G）：\n';
            for (let j = 0; j < oversizedFiles.length; j++) {
                tipText += `${oversizedFiles[j].name}（${oversizedFiles[j].size}）\n`;
            }
            message.error(tipText);
            this.fileInput.value = '';
            return;
        }

        // 2. 总大小校验（≤15G）
        const totalSize = files.reduce((sum, file) => {
            return sum + file.size;
        }, 0);
        if (totalSize > this.MAX_FOLDER_TOTAL_SIZE) {
            message.error(`文件夹总大小${this.formatSize(totalSize)}超过限制（≤${this.formatSize(this.MAX_FOLDER_TOTAL_SIZE)}），请重新选择`);
            this.fileInput.value = '';
            return;
        }

        // 3. 校验通过，初始化状态
        let folderName = '未知文件夹';
        if (files[0] && files[0].webkitRelativePath) {
            const pathParts = files[0].webkitRelativePath.split('/');
            folderName = pathParts[0] || '未知文件夹';
        }

        this.setState({
            selectedFiles: files,
            folderName: folderName,
            uploadStatus: 'idle',
            totalSize: totalSize,
            completedSize: 0,
            currentFileUploaded: 0,
            currentFileTotal: 0,
            totalFiles: files.length,
            uploadedFiles: 0,
            currentFileIndex: -1,
            failedFiles: [],
            isProcessing: false,
            uploadId: ''
        });
        this.isCanceled = false; // 重置取消标记
        message.info(`已选中文件夹：${folderName}（${this.formatSize(totalSize)}，共${files.length}个文件）`);
        this.fileInput.value = '';
    };

    // 格式化文件大小（字节→B/KB/MB/GB）
    formatSize = (bytes) => {
        if (bytes === 0) return '0B';
        const k = 1024;
        const units = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${(bytes / Math.pow(k, i)).toFixed(2)}${units[i]}`;
    };

    // 开始批量上传（初始化后调用逐个上传）
    startBatchUpload = () => {
        const { selectedFiles, version } = this.state;
        const { userId } = sessionStorage;

        if (!selectedFiles.length) {
            message.warning('请先选择文件夹');
            return;
        }
        if (this.state.uploadStatus === 'uploading') {
            message.warning('上传中，请等待');
            return;
        }
        if (!version) {
            message.warning('请输入文件夹版本号');
            return;
        }

        this.UploadFolderModalRef.changeVisible(false);

        // 初始化上传ID、状态
        const uploadId = `${Date.now()}_${userId}`;
        this.setState({
            uploadStatus: 'uploading',
            uploadId: uploadId,
            currentFileIndex: 0,
            completedSize: 0,
            currentFileUploaded: 0,
            currentFileTotal: 0,
            failedFiles: [],
            isProcessing: false
        }, () => {
            // 开始上传第一个文件
            this.uploadNextFile();
        });
    };
    // 新增操作日志
    submitAddFileLog = (operateType, operateFile) => {
        const { catalogId, pathName } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.deptFile.addFileLog,
            data:{
                catalogId,
                curUserId: sessionStorage.userId,
                operateType,
                fileCatalog: pathName.split('-->').join('->'),
                operateFile,
            },
            dataType: 'json',
            doneResult: res => {

            },
            errorResult: () => {

            }
        };
        $.sendRequest(options);
    }

    // 下载文件夹时添加操作日志（使用下载的文件夹ID和路径，而非当前选中目录）
    submitAddFileLogForDownloadCatalog = (operateType, catalogName, catalogId) => {
        const { treeData } = this.state;
        const path = this.findNodePath(treeData, catalogId);
        const fileCatalog = (path || []).map((node) => node.catalogName).join('->');
        const options = {
            method: 'POST',
            url: API_URL.deptFile.addFileLog,
            data:{
                catalogId,
                curUserId: sessionStorage.userId,
                operateType,
                fileCatalog,
                operateFile: catalogName,
            },
            dataType: 'json',
            doneResult: res => {

            },
            errorResult: () => {

            }
        };
        $.sendRequest(options);
    }

    // 逐个上传文件（核心：循环调用接口）
    uploadNextFile = () => {
        const { userId, curEmployeeCode } = sessionStorage;
        const { catalogId, currentFileIndex, totalFiles, uploadId, selectedFiles, version } = this.state;

        // 终止条件：1. 手动取消 2. 所有文件上传完成 3. 已有失败
        if (this.isCanceled) return;
        if (currentFileIndex >= totalFiles) {
            this.handleBatchUploadComplete();
            return;
        }
        if (this.state.failedFiles.length > 0) {
            this.handleBatchUploadFail('单个文件上传失败，终止批量上传');
            return;
        }

        // 获取当前要上传的文件（ES5判空）
        let currentFile = null;
        if (selectedFiles && selectedFiles[currentFileIndex]) {
            currentFile = selectedFiles[currentFileIndex];
        }
        if (!currentFile) {
            this.handleBatchUploadComplete();
            return;
        }

        // 初始化当前文件的进度状态
        this.setState({
            currentFileUploaded: 0,
            currentFileTotal: currentFile.size,
            isProcessing: false // 重置处理中标记
        });
        
        // 构造单个文件的FormData
        const formData = new FormData();
        formData.append('curUserId', userId);
        formData.append('curEmployeeCode', curEmployeeCode || '');
        formData.append('uploadId', uploadId);
        formData.append('catalogId', catalogId);
        formData.append('version', version); 
        formData.append('files', currentFile, currentFile.webkitRelativePath);
        formData.append(`relativePath_${currentFile.name}`, currentFile.webkitRelativePath);

        // 创建XHR请求
        this.xhr = new XMLHttpRequest();
        this.xhr.open('POST', API_URL.deptFile.uploadFolder, true);
        this.xhr.responseType = 'json'; // 解析JSON响应

        // 设置请求头xToken
        for (const key in xToken) {
            this.xhr.setRequestHeader(key, xToken[key]);
        }

        // 监听当前文件的上传进度（仅前端发送数据阶段）
        this.xhr.upload.addEventListener('progress', (e) => {
            if (e.lengthComputable && !this.isCanceled && !this.state.isProcessing) {
                // 更新当前文件发送进度
                this.setState({
                    currentFileUploaded: e.loaded
                });

                // 当当前文件发送完成（进度100%），标记为后台处理中
                if (e.loaded >= e.total) {
                    this.setState({
                        isProcessing: true
                    });
                }
            }
        });

        // 监听当前文件上传完成（包含后台处理响应）
        this.xhr.addEventListener('load', () => {
            if (this.isCanceled) {
                this.xhr = null;
                return;
            }

            // 1. 获取响应状态和数据（先获取再置空）
            const status = this.xhr.status;
            const response = this.xhr.response || {};
            this.xhr = null;

            // 2. 重置处理中标记
            this.setState({
                isProcessing: false
            });

            // 3. 双重校验成功状态
            const isSuccess = status >= 200 && status < 300 && response.success === '文件夹上传成功';
            
            if (isSuccess) {
                // 当前文件（发送+处理）成功：累加状态
                this.setState({
                    uploadedFiles: this.state.uploadedFiles + 1,
                    completedSize: this.state.completedSize + currentFile.size,
                    currentFileUploaded: 0,
                    currentFileTotal: 0,
                    currentFileIndex: currentFileIndex + 1,
                    fileCatalogPath: response.fileCatalogPath,
                }, () => {
                    // 递归上传下一个文件
                    this.uploadNextFile();
                });
            } else {
                // 当前文件失败：记录并终止
                let failReason = `HTTP ${status}: ${this.xhr ? this.xhr.statusText : '未知错误'}`;
                if (response && response.message) {
                    failReason += `，后台提示：${response.message}`;
                }
                const failedFiles = this.state.failedFiles;
                failedFiles.push({
                    name: currentFile.name,
                    reason: failReason
                });
                this.setState({
                    failedFiles: failedFiles,
                    currentFileUploaded: 0,
                    currentFileTotal: 0,
                    isProcessing: false
                }, () => {
                    this.handleBatchUploadFail(`文件 ${currentFile.name} 上传失败：${failReason}`);
                });
            }
        });

        // 监听网络错误
        this.xhr.addEventListener('error', () => {
            this.xhr = null;
            if (this.isCanceled) return;

            this.setState({
                isProcessing: false
            });
            const failedFiles = this.state.failedFiles;
            failedFiles.push({
                name: currentFile.name,
                reason: '网络异常/请求失败'
            });
            this.setState({
                failedFiles: failedFiles,
                currentFileUploaded: 0,
                currentFileTotal: 0
            }, () => {
                this.handleBatchUploadFail(`文件 ${currentFile.name} 上传失败：网络异常`);
            });
        });

        // 监听取消上传
        this.xhr.addEventListener('abort', () => {
            this.xhr = null;
            this.setState({
                isProcessing: false,
                currentFileUploaded: 0,
                currentFileTotal: 0
            });
            message.info(`文件 ${currentFile.name} 上传已取消`);
        });

        // 发送请求
        this.xhr.send(formData);
    };

    // 批量上传完成（所有文件成功）
    handleBatchUploadComplete = () => {
        const { totalSize, totalFiles, uploadId, folderName } = this.state;
        if (this.isCanceled) {
            this.setState({ 
                uploadStatus: 'idle',
                completedSize: 0,
                currentFileUploaded: 0,
                currentFileTotal: 0,
                isProcessing: false
            });
            message.info('批量上传已取消');
            return;
        }
        // 强制进度100%，标记完成
        this.setState({
            uploadStatus: 'success',
            currentFileIndex: -1,
            completedSize: totalSize,
            currentFileUploaded: 0,
            currentFileTotal: 0,
            isProcessing: false
        });
        message.success(`全部${totalFiles}个文件上传并处理成功`);
        
        // 调用文件夹上传成功回调函数（核心新增）
        if (uploadId) {
            this.uploadFolderSuccess(uploadId);
            this.loadData();
            // 新增操作日志
            this.submitAddFileLog('UPLOAD_FOLDER', folderName);
        }
    };

    // 批量上传失败（单个文件失败）
    handleBatchUploadFail = (tip) => {
        const { uploadedFiles, failedFiles } = this.state;
        this.setState({
            uploadStatus: 'error',
            currentFileIndex: -1,
            currentFileUploaded: 0,
            currentFileTotal: 0,
            isProcessing: false
        });
        message.error(tip);
        // 显示失败详情
        let failTip = '';
        for (let i = 0; i < failedFiles.length; i++) {
            failTip += `${failedFiles[i].name}：${failedFiles[i].reason}\n`;
        }
        if (failTip) {
            message.error(`失败文件列表：\n${failTip}`);
        }
    };

    // 取消批量上传（处理中阶段也可取消）
    cancelBatchUpload = () => {

        this.resetAllSettings();

        const { uploadId } = this.state;
        if (!uploadId) return;

        // 步骤2：调用后端取消上传接口
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.deptFile.cancelUpload,
            data: {
                uploadId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ loading: false });
                message.info('批量上传已取消');
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    };

    // 重置所有设置
    resetAllSettings = () => {
        // 1. 取消正在进行的上传（如果有）
        this.isCanceled = true;
        if (this.xhr) {
            this.xhr.abort(); // 终止当前XHR请求
            this.xhr = null; // 清空XHR实例
        }

        // 2. 重置所有状态为初始值
        this.setState({
            visible: false,
            selectedFiles: [], // 清空选中的文件列表
            folderName: '', // 清空文件夹名
            uploadStatus: 'idle', // 重置上传状态为闲置
            totalSize: 0, // 总大小重置
            completedSize: 0, // 已完成大小重置
            currentFileUploaded: 0, // 当前文件已上传大小重置
            currentFileTotal: 0, // 当前文件总大小重置
            totalFiles: 0, // 总文件数重置
            uploadedFiles: 0, // 已上传文件数重置
            uploadId: '', // 上传ID重置
            currentFileIndex: -1, // 当前文件索引重置
            failedFiles: [], // 失败文件列表清空
            isProcessing: false, // 处理中标记重置
            version: '',
        });

    }

    // 打开文件夹自定义函数
    handleOpenFolder = () => {
        const { fileCatalogPath } = this.state;
        const fileCatalogPathArr = fileCatalogPath.split('/');
        // 取除最后一个元素外的所有元素
        let otherArr = fileCatalogPathArr.slice(0, -1); 
        // 取最后一个元素（数组形式）
        let lastArr = fileCatalogPathArr.slice(-1);   
        console.log(fileCatalogPathArr, lastArr);
        
        this.setState({
            expandedKeys: otherArr,
            selectedKeys: lastArr,
        },() => {
            // 这里需要后端再给一个目录权限字段premission
            this.onSelect(lastArr[0]);
        });
    };

    // 打开文件夹选择窗口
    openFolderSelector = () => {
        const { uploadStatus } = this.state;
        if (uploadStatus === 'uploading') {
            message.warning('上传中，暂无法选择新文件夹');
            return;
        }
        this.fileInput.click();
    };

    //修改文件夹版本号
    handleVersionChange = (value) => {
        this.setState({ version: value });
    }

    resetFolderSelector = () => {
        this.setState({
            folderName: '',
            totalSize: 0,
            totalFiles: 0,
            uploadedFiles: 0,
            currentFileIndex: -1,
            failedFiles: [],
            isProcessing: false,
            selectedFiles: [],
        });
    }

    render() {
        const {
            treeData,
            tableData,
            loading,
            pagination,
            searchValue = '',
            expandedKeys,
            selectedKeys,
            autoExpandParent,
            catalogId,
            selectedRowKeys,
            pathName,
            majorEventsStatus,
            curPremission,
            curOtherPremission,
            canAddFirCatalog,

            // 以下字段均为上传文件夹用到的字段
            selectedFiles, // 选中的文件列表
            folderName, // 选中的文件夹名
            uploadStatus, // idle/上传中/success/error
            totalSize, // 总文件大小（字节）
            completedSize, // 已完成上传+处理的文件总字节
            currentFileUploaded, // 当前文件已上传字节（发送阶段）
            currentFileTotal, // 当前文件的总字节（用于判断是否发送完成）
            totalFiles, // 总文件数量
            uploadedFiles, // 已上传+处理成功的文件数
            uploadId, // 上传ID
            currentFileIndex, // 当前正在上传的文件索引
            failedFiles, // 上传失败的文件列表
            isProcessing, // 标记：当前文件是否处于后台处理阶段（发送完成，等待响应）
            version,  // 文件夹版本号
        } = this.state;
        const pathNameArr = pathName.split('-->');
        let pathNameshow = pathNameArr.slice(0, 3).join('-->');
        if(pathNameArr.length > 3) {
            pathNameshow += '...';
        }
        const loop = (data, isChildren) => (data || []).map(item => {
            const { id, catalogName, catalogIndex, premission, otherPremission } = item;
            const isSearch = searchValue ? catalogName.includes(searchValue) : false;
            const fontContent = <Tooltip placement="right" title={catalogName}>
                <span className='ellipsis'>{catalogName}</span>
            </Tooltip>;
            const editCatalogKey = catalogIndex == 1 ? 'editFirCatalog' : 'editCatalog';

            // 判断是否有下载权限（OWNER/COMMON/CRC下载权限）
            const canDownload = catalogIndex >= 2 && (
                premission == 'OWNER' ||
                premission == 'COMMON' ||
                (otherPremission || '').split(',').includes('DOWNLOAD_FILE')
            );

            // 判断是否有下载文件夹权限（仅OWNER且非一级目录）
            const canDownloadFolder = catalogIndex > 1 && premission == 'OWNER';

            const title =
                <div className='catalog_content' style={{ marginTop:  0, backgroundColor: isSearch ? '#cfe8fc' : undefined }}>
                    {
                        <span
                            style={{ display: 'flex' }}
                            onClick={() => this.onSelect(id, premission)}
                        >
                            <Icon type="folder-open" style={{ marginRight: 3, color: '#5959df' }} />
                            {fontContent}
                        </span>
                    }
                    {/* 添加目录 */}
                    {
                        premission == 'OWNER' && <span onClick={() => this.updateCatalog('addCatalog', id)} className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="plus-circle-o" /></span>
                    }
                    {/* 删除目录 */}
                    {
                        (canAddFirCatalog && !isChildren || isChildren) && premission == 'OWNER' && <span onClick={() => this.deleteCatalog(id, catalogIndex)} className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="minus-circle-o" /></span>
                    }
                    {/* 修改目录 */}
                    {
                        (canAddFirCatalog && !isChildren || isChildren) && premission == 'OWNER' && <span onClick={() => this.updateCatalog(editCatalogKey, id, catalogName)} className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="edit" /></span>
                    }
                    {/* 配置目录权限 */}
                    {
                        premission == 'OWNER' && <span
                            className='fileIcon_style'
                            onClick={() => this.configPermission({id, catalogName})}
                        >
                            <Icon style={{ fontSize: 16 }} type="safety" />
                        </span>
                    }
                    {/* 迁移到项目内（OWNER权限且非一级目录时显示） */}
                    {
                        premission == 'OWNER' && catalogIndex > 1 && <Tooltip title="文件移动到项目内">
                            <span
                                className='fileIcon_style'
                                onClick={(e) => { e.stopPropagation(); this.moveFolderToInv(id, catalogName, catalogIndex); }}
                            >
                                <Icon style={{ fontSize: 14 }} type="arrow-right" />
                            </span>
                        </Tooltip>
                    }
                    {/* 移动文件夹（OWNER权限且非一级目录时显示） */}
                    {
                        premission == 'OWNER' && catalogIndex > 1 && <Tooltip title="移动文件夹">
                            <span
                                className='fileIcon_style'
                                onClick={(e) => { e.stopPropagation(); this.showMoveFolder(id, catalogName); }}
                            >
                                <Icon style={{ fontSize: 14 }} type="export" />
                            </span>
                        </Tooltip>
                    }
                    {/* 下载文件夹（仅OWNER且非一级目录时显示） */}
                    {
                        canDownloadFolder && <span
                            className='fileIcon_style'
                            onClick={(e) => { e.stopPropagation(); this.downloadFolder(id, catalogName, catalogIndex); }}
                        >
                            <Icon style={{ fontSize: 14 }} type="download" />
                        </span>
                    }

                </div>;
            return (
                <TreeNode key={String(item.id)} title={title}>
                    {loop(item.children, true)}
                </TreeNode>
            );
        });

        // 树数据/搜索值/权限无变化时复用缓存，避免每次 setState（展开/选中/搜索）都 O(N) 全量重建
        if (this._lastTreeData !== treeData
            || this._lastSearchValue !== searchValue
            || this._lastCanAddFirCatalog !== canAddFirCatalog) {
            this._renderedTreeCache = loop(treeData);
            this._lastTreeData = treeData;
            this._lastSearchValue = searchValue;
            this._lastCanAddFirCatalog = canAddFirCatalog;
        }

        const rowSelection = {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
            getCheckboxProps: record => ({
                // disabled: !record.batchDownloadFlag,
            }),
        };

        const canUploadFolder = curPremission === 'OWNER';
        const menu = (
            <Menu onClick={this.handleMenuClick}>
                <Menu.Item key="file">上传文件</Menu.Item>
                {canUploadFolder && <Menu.Item key="folder">上传文件夹</Menu.Item>}
            </Menu>
        );

        return (
            <div className="content">
                <SideNav selectKey='departmentalDocuments' />
                <div className="main" style={{ display: majorEventsStatus ? 'none' : undefined }}>
                    <Spin spinning={loading}>
                    <div className='file_content'>
                        <div className='left'>
                            <div style={{ marginBottom: 8 }}>
                                <Select
                                    style={{ width: 70 }}
                                    defaultValue={'文件夹'}
                                >
                                    <Option value={'文件夹'}>{'文件夹'}</Option>
                                </Select>
                                <Search style={{ width: 150 }} placeholder="请输入" onChange={this.onFolderSearchChange} onSearch={this.onFolderSearch} />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                                <Select
                                    style={{ width: 70 }}
                                    defaultValue={'文件名'}
                                >
                                    <Option value={'文件名'}>{'文件名'}</Option>
                                </Select>
                                <Search style={{ width: 150 }} placeholder="请输入" onChange={this.onFileNameChange} onSearch={this.onFileNameSearch} />
                            </div>
                            <div style={{ marginLeft: 8, marginTop: 8, marginBottom: 10 }}>
                                {
                                    canAddFirCatalog && <Button
                                        key="creatFirCatalog"
                                        type="primary"
                                        style={{ marginRight: 10 }}
                                        onClick={() => this.updateCatalog('addFirCatalog')}
                                    >新增一级目录</Button>
                                }
                                <Button
                                    key="viewFileLog"
                                    type="primary"
                                    onClick={this.viewFilelog}
                                >操作日志</Button>
                            </div>
                            <Tree
                                showLine
                                onExpand={this.onExpand}
                                onSelect={this.onTreeNodeSelect}
                                expandedKeys={expandedKeys}
                                selectedKeys={selectedKeys}
                                autoExpandParent={autoExpandParent}
                            >
                                {this._renderedTreeCache}
                            </Tree>
                        </div>
                        <div className='right'>
                            <div className='table_content'>
                            <div className='table_top'>
                                <div className='top_left'>
                                    <Icon style={{ marginRight: 5 }} type="environment-o" />
                                    {
                                        !!pathNameshow && pathNameshow !== 'undefined' && 
                                        <Tooltip title={pathName}>
                                            {pathNameshow}
                                        </Tooltip>
                                    }
                                </div>
                                <div className='top_right'>
                                    {(curPremission == 'COMMON' || curPremission == 'OWNER' || (curOtherPremission || '').split(',').includes('DOWNLOAD_FILE')) &&
                                        <Button
                                            key="downloadFileBatch"
                                            type="primary"
                                            onClick={this.downloadFileBatch}
                                        >批量下载</Button>
                                    }

                                    {(curPremission == 'OWNER' || (curOtherPremission || '').split(',').includes('UPLOAD_FILE')) && uploadStatus !== 'uploading' &&
                                        <Dropdown overlay={menu}>
                                            <Button
                                                style={{ marginLeft: 20 }}
                                                type="primary"
                                            >上传</Button>
                                        </Dropdown>
                                    }
                                    {(curPremission == 'OWNER' || (curOtherPremission || '').split(',').includes('UPLOAD_FILE')) && uploadStatus === 'uploading' &&
                                        <Button
                                            style={{ marginLeft: 20 }}
                                            type="primary"
                                            disabled={uploadStatus === 'uploading'}
                                        >上传</Button>
                                    }
                                </div>

                            </div>
                            <Table
                                bordered
                                rowSelection={rowSelection}
                                rowKey={record => record.index}
                                pagination={pagination}
                                dataSource={tableData}
                                scroll={{ x: 500 }}
                                columns={this.getColumns()}
                                onChange={this.handleTableChange}
                            />
                            </div>
                            
                            <div className='progress'>
                                {/* 进度条框 */}
                                <FolderUploadProgress
                                    loadData={this.loadData} 
                                    loading={loading}

                                    selectedFiles={selectedFiles} // 选中的文件列表
                                    folderName={folderName} // 选中的文件夹名
                                    uploadStatus={uploadStatus} // idle/上传中/success/error
                                    totalSize={totalSize} // 总文件大小（字节）
                                    completedSize={completedSize} // 已完成上传+处理的文件总字节
                                    currentFileUploaded={currentFileUploaded} // 当前文件已上传字节
                                    totalFiles={totalFiles} // 总文件数量
                                    uploadedFiles={uploadedFiles} // 已上传+处理成功的文件数
                                    currentFileIndex={currentFileIndex} // 当前正在上传的文件索引
                                    failedFiles={failedFiles} // 上传失败的文件列表
                                    isProcessing={isProcessing} // 标记：当前文件是否处于后台处理阶段

                                    cancelBatchUpload={this.cancelBatchUpload}
                                    resetAllSettings={this.resetAllSettings}
                                    formatSize={this.formatSize}
                                    handleOpenFolder={this.handleOpenFolder}
                                />
                            </div>
                            
                        </div>
                    </div>
                    <UpdateCatalog ref={el => this.UpdateCatalogRef = el} loadData={this.loadData} />
                    <UploadFileModal 
                        ref={el => this.UploadFileModalRef = el} 
                        queryTableData={this.queryTableData} 
                        catalogId={catalogId}
                        pathName={pathName}
                    />
                    <PermissionConfig 
                        ref={el => this.PermissionConfigRef = el}
                        loadData={this.loadData} 
                        catalogId={catalogId}
                    />
                    {/* 上传文件夹弹窗 */}
                    <UploadFolderModal 
                        ref={el => this.UploadFolderModalRef = el} 
                        loadData={this.loadData} 
                        catalogId={catalogId}
                        pathName={pathName}
                        loading={loading}

                        selectedFiles={selectedFiles} // 选中的文件列表
                        folderName={folderName} // 选中的文件夹名
                        uploadStatus={uploadStatus} // idle/上传中/success/error
                        totalSize={totalSize} // 总文件大小（字节）
                        totalFiles={totalFiles} // 总文件数量
                        currentFileIndex={currentFileIndex} // 当前正在上传的文件索引
                        isProcessing={isProcessing} // 标记：当前文件是否处于后台处理阶段
                        version={version}  //文件夹版本号

                        startBatchUpload={this.startBatchUpload}
                        openFolderSelector={this.openFolderSelector}
                        resetFolderSelector={this.resetFolderSelector}
                        formatSize={this.formatSize}
                        handleVersionChange={this.handleVersionChange}
                        resetAllSettings={this.resetAllSettings}
                    />
                    </Spin>
                    <FileLogModal ref={el => this.FileLogModalRef = el} />
                    <FolderMoveToInv ref={el => this.FolderMoveToInvRef = el} onSuccess={this.loadData} />
                    <MoveFolderModal ref={el => this.MoveFolderModalRef = el} onSuccess={this.loadData} />
                </div>
            </div>
        )
    }
}

export default DepartmentalDocuments





// WEBPACK FOOTER //
// ./src/components/documentManagement/departmentalDocuments/index.js